RivalIQ.apps.Dashboard.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Configuration = Marionette.Dashboard.models.Configuration.extend({
        url: function () {
            const me = this;

            let path;
            if (me.get('type') === RivalIQ.enums.visibility.ACCOUNT) {
                path = ['/api/accounts', me.get('account_id')];
            } else {
                path = ['/api/landscapes', me.get('landscape_id')];
            }

            path = path.concat(['configurations', me.get('curation_id'), me.id]);

            return path.join('/');
        },
        reorderDefinitions: function (newOrder) {
            const me = this;
            const definitions = me.get('definitions');
            const newDefinitions = _.map(newOrder, function (i) {
                return definitions[i];
            });

            if (me.widgetsCached()) {
                me._widgetsCache.comparator = function (model) {
                    // NOTE arguments is required bc if there are two args
                    // backbone sends down two models
                    return _.indexOf(newOrder, arguments[1]);
                };
                me._widgetsCache.sort();
                me._widgetsCache.comparator = null;
            }

            const url = `${me.url()}/definitions`;
            return me.save({
                definitions: newDefinitions
            }, {
                url: url
            });
        }
    });

    models.WidgetConfiguration = models.Configuration.extend({
        url: function () {
            const me = this;

            return [
                me.parent.url({
                    widget: true
                }),
                'definitions',
                me.get('instanceId')
            ].join('/');
        }
    });
});
